/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { ApiError } from 'cio/services/api';
import { TaskInstance } from 'ember-concurrency';

interface CioSendTestContentStatusArgs {
  failedToSend: boolean;
  errors: ApiError[] | null;
  sendTest: TaskInstance<unknown>;
}

export default class CioSendTestContentStatus extends Component<CioSendTestContentStatusArgs> {}
